import React, { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import ahamaIcon from '../img/ahama-icon.svg';

/* Program ve görseller GWS uygulamasındaki "Yacht Weekend at Port Azure Göcek"
   etkinliğinden alındı */
const STORAGE = 'https://yzzynxgixflgjzvotiae.supabase.co/storage/v1/object/public/event-images';

const heroImg = `${STORAGE}/event-1791555546841.jpg`;
const ahamaImg = `${STORAGE}/sub-event-1791554241479.jpg`;
const portAzureImg = `${STORAGE}/sub-event-1791554788972.jpg`;
const orientStarImg = `${STORAGE}/sub-event-1791555070533.jpg`;

const headingFont = { fontFamily: "'Spirits Soft', 'Figtree', sans-serif" };

const days = [
  {
    title: 'Varış',
    date: '23 Ekim 2026 / Cuma',
    img: portAzureImg,
    alt: 'Port Azure Göcek',
    items: [
      [<span className="underline">Uçuş Bilgileri</span>, <><br />Sabiha Gökçen / AJet / 10:00 / VF3422<br />İstanbul Havalimanı / THY / 10:00 / TK2556</>],
      ['13.30:', 'Ahãma Living’den tekne ile Miori’ye geçiş ve öğle yemeği'],
      ['16.00:', 'Ahãma Living’e dönüş ve serbest zaman'],
      ['16.30:', 'Sound healing'],
      ['19.30:', 'Ahãma Living’den tekne ile Port Azure’a geçiş. Orkan Uzunyayla’nın ev sahipliğinde barbekü ve oyun gecesi.'],
    ],
  },
  {
    title: 'Orient Star ile Denizde Bir Gün',
    date: '24 Ekim 2026 / Cumartesi',
    img: orientStarImg,
    alt: 'Orient Star',
    items: [
      ['08.30:', 'Ahãma’yı çevreleyen ormanda yürüyüş, ardından kahvaltı'],
      ['11.00:', 'Orient Star ile denize açılıyoruz. Koyları gezecek ve yatçılık üzerine sohbet edeceğiz.'],
      ['17.00:', 'Ahãma Living’e dönüş ve serbest zaman'],
      ['19.30:', 'Tekne ile Balıkçı Özcan’a geçiş ve akşam yemeği'],
    ],
  },
  {
    title: 'Yavaş Bir Sabah & Dönüş',
    date: '25 Ekim 2026 / Pazar',
    img: ahamaImg,
    alt: 'Ahãma Living',
    items: [
      ['08.00:', 'Yoga'],
      ['09.00:', 'Kahvaltı ve serbest zaman'],
    ],
    note: 'Pazar günü dönüş uçuşunu dilediğiniz saate alabilirsiniz.',
  },
];

const venues = [
  {
    name: 'Ahãma Living',
    text: 'Göcek’in hemen dışında, Günlüklü Koyu’nda korunan bir ormanın içinde yer alıyor. Adı “sevgili” anlamına gelen kadim bir Likya kelimesinden geliyor ve felsefesi de buna uyuyor: yavaş yaşam, doğayı önceleyen bir yaklaşım ve huzurlu bir konaklama. 2024’te açılan Ahãma, Relais & Châteaux üyesi ve bir MICHELIN Key sahibi.',
  },
  {
    name: 'Port Azure Göcek',
    text: 'Türkiye’nin yalnızca süper yatlar için inşa edilmiş ilk marina ve yat kulübü. STFA tarafından 2021’de Göcek’in korunaklı Büngüş Koyu’nda açılan Port Azure, Avrupa’nın en uzunlarından biri olan 245 metrelik beton iskelesinde 150 metreye kadar yatları ağırlıyor. Dalaman Havalimanı’na yalnızca 23 km uzaklıkta.',
  },
  {
    name: 'Orient Star',
    text: 'STFA’nın 47 metrelik motor yatı; Antalya’da CMB Yachts tarafından inşa edildi ve 2012’de teslim edildi. İç mekânları baştan sona Tara Bernerd & Partners imzası taşıyor. Beş kabininde 10 misafir ağırlayan yatın flybridge’inde jakuzi ve güneşlenme güvertesi bulunuyor.',
  },
];

const GocekLanding = () => {
  useEffect(() => {
    document.title = 'Port Azure’da Yatçılık Üzerine Bir Hafta Sonu — GWS';
  }, []);

  return (
    <div className="relative w-full overflow-x-hidden">
      {/* Navbar - Standard Layout, No Menu Links */}
      <nav className="absolute top-0 left-0 right-0 z-50 py-6">
        <div className="max-w-[1920px] mx-auto px-8 lg:px-16">
          <div className="flex items-center justify-center">
            <div className="flex flex-col items-center group cursor-default">
              <img
                src="https://customer-assets.emergentagent.com/job_wealth-legacy-2/artifacts/vulhojge_gws.png"
                alt="GWS Logo"
                className="h-12 w-auto group-hover:scale-110 transition-transform duration-500"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-screen w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={heroImg}
            alt="Port Azure Göcek"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#587c8d]/80 via-[#587c8d]/65 to-[#587c8d]/95" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#587c8d]/40 to-transparent" />
        </div>

        <div className="relative z-10 flex flex-col justify-center items-center h-full w-full px-8 pb-32 text-center">
          <div className="max-w-4xl">
            <p className="text-white text-sm lg:text-base font-medium tracking-widest uppercase mb-4 drop-shadow-md">
              Göcek
            </p>
            <h1 className="text-[#f8f8f8] text-5xl lg:text-8xl font-bold leading-tight mb-6 drop-shadow-lg" style={headingFont}>
              Port Azure’da Yatçılık Üzerine Bir Hafta Sonu
            </h1>
            <div className="text-[#f8f8f8] text-2xl lg:text-3xl font-bold mb-8 drop-shadow-md">
              23 - 25 Ekim 2026
            </div>
          </div>
        </div>

        <div className="absolute bottom-36 left-0 right-0 z-10 px-8 text-center flex justify-center">
          <div className="flex flex-col items-center">
            <p className="text-[#e4a483] text-base lg:text-xl font-bold leading-relaxed lg:whitespace-nowrap drop-shadow-md mb-1">
              Orkan Uzunyayla’nın ev sahipliğinde, Türkiye’nin ilk mega yat marinası Port Azure’u deneyimliyoruz.
            </p>
            <p className="text-[#e4a483] text-base lg:text-xl font-medium italic leading-relaxed drop-shadow-md">
              KONAKLAMA: Ahãma Living
            </p>
            <img
              src={ahamaIcon}
              alt="Ahãma Living"
              className="h-10 w-auto mt-4"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>
        </div>

        <div
          onClick={() => document.getElementById('program')?.scrollIntoView({ behavior: 'smooth' })}
          className="absolute bottom-8 left-0 right-0 mx-auto w-8 z-20 cursor-pointer animate-bounce group"
        >
          <div className="flex flex-col items-center gap-2">
            <ChevronDown className="w-8 h-8 text-white/60 group-hover:text-white/90 transition-colors" />
          </div>
        </div>
      </section>

      {/* Program Section */}
      <section id="program" className="bg-[#f9fafb] py-10 lg:py-16 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.08] pointer-events-none grayscale"
          style={{
            backgroundImage: `url("https://customer-assets.emergentagent.com/job_wealth-legacy-2/artifacts/vulhojge_gws.png")`,
            backgroundSize: '120px',
            backgroundRepeat: 'space'
          }}
        />

        <div className="max-w-[1920px] mx-auto px-8 lg:px-16 relative z-10">
          <div className="flex flex-col gap-16 lg:gap-24">
            {days.map((day, i) => (
              <div
                key={day.title}
                className={`flex flex-col ${i % 2 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-24 items-center`}
              >
                {/* Image Side */}
                <div className="w-full lg:w-1/2">
                  <div className="relative aspect-[4/3] overflow-hidden rounded-lg shadow-2xl">
                    <img
                      src={day.img}
                      alt={day.alt}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                </div>

                {/* Content Side */}
                <div className="w-full lg:w-1/2">
                  <div className="flex items-center gap-4 mb-8">
                    <div className="w-12 h-12 rounded-full bg-[#1a441f] flex items-center justify-center text-[#e4a483] font-bold text-xl shrink-0">{i + 1}</div>
                    <div className="flex flex-wrap items-baseline gap-x-4">
                      <h3 className="text-[#1a441f] text-2xl lg:text-3xl font-bold" style={headingFont}>
                        {day.title}
                      </h3>
                      <span className="text-[#587c8d] font-medium tracking-widest text-sm uppercase">— {day.date}</span>
                    </div>
                  </div>

                  <ul className="space-y-4 text-[#587c8d] font-medium leading-relaxed list-none p-0 m-0">
                    {day.items.map(([time, text], j) => (
                      <li key={j} className="block">
                        <span className="font-bold text-lg text-[#1a441f]">{time}</span> {text}
                      </li>
                    ))}
                  </ul>

                  {day.note && (
                    <p className="mt-8 text-[#587c8d] font-medium leading-relaxed">
                      <span className="font-bold text-lg text-[#1a441f]">Not:</span> {day.note}
                    </p>
                  )}
                </div>
              </div>
            ))}

            {/* Venues */}
            <div>
              <h3 className="text-[#1a441f] text-2xl lg:text-3xl font-bold mb-8" style={headingFont}>
                Mekânlar
              </h3>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                {venues.map((venue) => (
                  <div key={venue.name}>
                    <h4 className="text-[#1a441f] text-lg font-bold mb-3">{venue.name}</h4>
                    <p className="text-[#587c8d] leading-relaxed">{venue.text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Important Information */}
            <div>
              <h3 className="text-[#1a441f] text-2xl lg:text-3xl font-bold mb-8" style={headingFont}>
                Önemli Bilgilendirmeler
              </h3>

              <div className="space-y-2 text-[#587c8d] leading-relaxed">
                <p>
                  Bu program GWS üyeleri için özel olarak hazırlanmıştır. Konaklama masrafları doğrudan otele ödenecektir. Miori ve Balıkçı Özcan’daki yemekler misafirler tarafından karşılanacaktır. Cuma saat 10.00 uçağı ile gelecek olanlar için transferimiz ayarlanmıştır. Dönüş uçuşu için uçak saatlerine göre transfer ayarlanacaktır.
                </p>
                <p>
                  Program, 23 Ekim Cuma günkü 10.00 Dalaman uçuşuna göre organize edilmiştir. Farklı saatlerde seyahat etmeyi tercih eden misafirlerimizin, transfer ve bağlantılarını bireysel olarak organize etmeleri beklenmektedir.
                </p>
                <p>
                  Güverte ayakkabılarınızı ve mayolarınızı unutmayın.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GocekLanding;
